import type { UseMutationOptions } from "@tanstack/react-query";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  mapPasskeyError,
  startPasskeyRegistration,
} from "gsintegrations";
import {
  passkeyQueryKeys,
  passkeyRepository,
} from "../repositories/passkey.repository";
import { markPasskeyRegisteredOnDevice } from "../utils/passkeyDeviceStorage";

export const usePasskeyRegisterMutation = (
  options?: UseMutationOptions<unknown, Error, void>,
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      const { options: registrationOptions } =
        await passkeyRepository.getRegistrationOptions();
      const response = await startPasskeyRegistration(registrationOptions);
      return passkeyRepository.verifyRegistration(response);
    },
    ...options,
    onSuccess: async (data, variables, context) => {
      markPasskeyRegisteredOnDevice();
      await queryClient.invalidateQueries({
        queryKey: passkeyQueryKeys.credentials,
      });
      options?.onSuccess?.(data, variables, context);
    },
    onError: (error, variables, context) => {
      options?.onError?.(
        new Error(mapPasskeyError(error)),
        variables,
        context,
      );
    },
  });
};

export default usePasskeyRegisterMutation;
